import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

/**
 * Loader component
 */
const Loader = () => (
  <ClipLoader
    sizeUnit={"px"}
    size={32}
    color={'#f3f3f3'}
    loading={true}
  />
);

export default Loader;
